import * as React from "react";
import { Map } from "../../components/map";
import * as styles from "./styles.css";
var InfoMap = function (_a) {
    var coordinates = _a.coordinates;
    return (React.createElement(Map.Static, { className: styles.infoMap, coordinates: coordinates, dimensions: "80x80" }));
};
export default InfoMap;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/info/infoMap.tsx
// module id = TyI8
// module chunks = 2